module.exports = __webpack_public_path__ + "img/item9.efa22f83.svg";